module.exports = __webpack_public_path__ + "media/images/logo/product-family-aac94820a1c2e2c725b43c4dc2e1c84e.png";